import React from 'react';

export interface EmptyStateProps {
  icon?: string;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState = ({ 
  icon = 'ri-inbox-2-line', 
  title = 'Không có dữ liệu', 
  description = 'Hiện tại chưa có thông tin nào để hiển thị.', 
  action, 
  className = '' 
}: EmptyStateProps) => {
  return (
    <div className={`flex flex-col items-center justify-center p-8 text-center bg-slate-50 rounded-md border border-slate-100 border-dashed ${className}`}>
      <div className="w-16 h-16 flex items-center justify-center bg-slate-100 rounded-full mb-4">
        <i className={`${icon} text-3xl text-slate-400`}></i>
      </div>
      <h3 className="sm:text-sm text-xs text-slate-900 mb-1">{title}</h3>
      <p className="sm:text-sm text-xs text-slate-500 max-w-sm mb-4">{description}</p>
      {action && <div>{action}</div>}
    </div>
  );
};
